

























































































































































































































import { Vue, Component, Prop } from "vue-property-decorator";
import RequestHandler from "@/assets/ts/requestHandler";
const requestHandler = new RequestHandler();

@Component
export default class CartTable extends Vue {
  @Prop({ required: true }) cartItems!: Array<any>;
  @Prop({ required: true }) tableHeaders!: Array<any>;
  @Prop({ required: true }) apiFields!: Array<any>;
  formRules = {
    required: [
      (v: string | any) =>
        [null, undefined, ""].includes(v) ? "Required" : true
    ],
    amount: [
      (v: string | any) =>
        [null, undefined, "", "0"].includes(v) ? "Required" : true
    ]
  };
  taxLoading = false;

  filterNumber(event: any) {
    if (["e", "+", "-"].includes(event.key)) {
      event.preventDefault();
    }
  }

  handleFieldChange(field: any, item: any) {
    if (this.$store.getters.userInfo.Service != "TaxPayments") return;
    if (["rct", "year"].includes(field.DBFieldName)) {
      this.searchTaxBills(item, item.type);
    } else if (
      ["penaltyAndInterest", "field4Val"].includes(field.DBFieldName)
    ) {
      this.calculateTaxAmountField(item);
    }
  }

  calculateTaxAmountField(item: any) {
    item.amount = "0.00";
    item.fields[item.type].forEach(
      (field: { DBFieldName: string; value: string }, index: number) => {
        if (["penaltyAndInterest", "field4Val"].includes(field.DBFieldName))
          item.amount = parseFloat(item.amount) + parseFloat(field.value);
      }
    );
    item.amount = (Math.round( item.amount * 100 ) / 100).toFixed(2)
  }

  async searchTaxBills(item: { fields: any; amount: string }, type: string) {
    let rct = "";
    let year = "";
    let PIindex = NaN;
    let Billindex = NaN;
    item.fields[type].forEach(
      (field: { DBFieldName: string; value: string }, index: number) => {
        if (field.DBFieldName === "rct") rct = field.value;
        else if (field.DBFieldName === "year") year = field.value;
        else if (field.DBFieldName === "penaltyAndInterest") PIindex = index;
        else if (field.DBFieldName === "field4Val") Billindex = index;
      }
    );
    if (rct == "" || year == "") return;
    try {
      let calcualtedTotalAmount = 0.00;
      this.taxLoading = true;
      const response: Array<{
        amountDue: number;
        totalAmountRemaining: number;
        penaltyAmount: number;
      }> = await requestHandler.call({
        action: "getTaxBills",
        rct: rct,
        year: year.toString()
      });
      if (!isNaN(PIindex)) {
        item.fields[type][PIindex].value = response[0].penaltyAmount.toFixed(2);
        calcualtedTotalAmount += response[0].penaltyAmount
      }
      if (!isNaN(Billindex)) {
        item.fields[type][
          Billindex
        ].value = response[0].totalAmountRemaining.toFixed(2);
       calcualtedTotalAmount += response[0].totalAmountRemaining
      }
      if(response[0].amountDue === 0.00) {
        item.amount = calcualtedTotalAmount.toFixed(2);
      } else {
        item.amount = response[0].amountDue.toFixed(2);
      }
    } catch (e) {
      console.error(e);
      this.$root.$emit("snackbar-message", {
        text: "Could not find bill with matching receipt and year.",
        color: "red"
      });
      item.amount = "0.00";
      item.fields[type][PIindex].value = "0.00";
      item.fields[type][Billindex].value = "0.00";
    } finally {
      this.taxLoading = false;
    }
  }

  get fixedTableHeight(): string {
    if (this.$vuetify.breakpoint.width < 960) return "100%";
    return "calc(100vh - 50px - 30px*8)";
  }

  editCartItem(id: number) {
    if (!this.validateAllCartItems()) return;

    this.cartItems.forEach((item: { id: number; isBeingEdited: boolean }) => {
      if (item.id === id) item.isBeingEdited = true;
      else item.isBeingEdited = false;
    });
  }

  deleteCartItem(id: number) {
    for (let i = 0; i < this.cartItems.length; i++) {
      if (this.cartItems[i].id === id) this.cartItems.splice(i, 1);
    }
  }

  clearCart() {
    this.cartItems.splice(0, this.cartItems.length);
    this.addNewItem();
  }

  validateAllCartItems(lockFields = true): boolean {
    try {
      this.cartItems.forEach(
        (item: {
          isBeingEdited: boolean;
          amount: string;
          fields: any;
          type: string;
        }) => {
          if (item.isBeingEdited) {
            if (!(parseFloat(item.amount) > 0)) throw "required field";
            item.fields[item.type].forEach(
              (field: { value: string; required: number }) => {
                if (
                  field.required === 1 &&
                  ["", null, undefined].includes(field.value)
                ) {
                  throw "required field";
                }
              }
            );
          }
          if (lockFields) item.isBeingEdited = false;
        }
      );
      return true;
    } catch (e) {
      console.error(e);
      if (lockFields) {
        this.$root.$emit("snackbar-message", {
          text: "All required fields must be filled.",
          color: "red"
        });
      }
      return false;
    }
  }

  addNewItem() {
    if (!this.validateAllCartItems()) return;

    const newCartItem: { fields: any } = { fields: {} };
    this.apiFields.forEach(
      (optionType: { fields: any; optionType: string }) => {
        Vue.set(newCartItem.fields, optionType.optionType, []);
        optionType.fields.forEach((field: any) => {
          newCartItem["fields"][optionType.optionType].push(
            field.possibleValues != undefined &&
              field.possibleValues.length == 1
              ? Object.assign({}, field, {
                  value: field.possibleValues[0].value
                })
              : Object.assign({}, field, { value: "" })
          );
        });
      }
    );
    Vue.set(newCartItem, "isBeingEdited", true);
    Vue.set(newCartItem, "amount", 0);
    Vue.set(
      newCartItem,
      "type",
      this.apiFields.length > 1 ? null : this.apiFields[0].optionType
    );
    Vue.set(newCartItem, "id", Date.now().toString());
    this.cartItems.push(Object.assign({}, newCartItem));
  }
}
